import container from './SecondaryNavigation';

export default container;



// WEBPACK FOOTER //
// ./src/js/secondaryNavigation/index.js